import React from 'react'
import Layout from '../../Layout/Layout'
import lab from '../../images/lab.PNG'

const Lab_to_market = () => {
  return (
     <Layout>
        <div className='uk-container'>
            <div><h2 className='light uk-text-bold uk-margin-xlarge-top'>From Lab to Market R2C Toolkit Development</h2></div>
            <div className='uk-grid'>
               <div className='uk-width-1-2@s'>
                      <p className='light'>
            The "From Lab to Market" toolkit is a comprehensive 
            Research to Commercialization (R2C) Guide for Nigerian 
            Researchers, Innovators, and Entrepreneurs. This landmark 
            study was commissioned by the Nigeria Impact Investing Research
             and Industry Collaborative (NIIRIC), an initiative of the
              Impact Investors Foundation (IIF) and the National Advisory
               Board for Impact Investing (NABII). Funding for this 
               material was provided by the UK International Development
                from the UK Government through the RISA Fund. The guide's 
                purpose is to facilitate the systematic process of converting 
                research outputs and inventions into viable, market-ready products
                 and services that deliver economic and social value. 
</p>

                <p className='light'>The core of the guide is the Integrated R2C Framework, 
                    which utilizes a structured Stage-Gate Approach to manage the innovation
                     lifecycle. This framework is divided into four distinct phases, starting 
                     with Phase 1: Discovery and Ideation (Technology Readiness Levels 1–3). 
                     This is followed by Phase 2: Scoping and Intellectual Property Protection,
                      which addresses IP strategy and formal protection. The framework continues
                       with Phase 3: Development and Validation (TRL 6–7), before concluding with
                        Phase 4: Market Strategy and Launch.
</p>

                <p className='light'>
                    Beyond the R2C framework, the toolkit offers detailed guidance on
                     crucial commercialization components. These include chapters on Intellectual
                      Property (IP) Protection and Management within the Nigerian legal framework,
                       and the selection of an optimal Commercialisation Pathway (e.g., Licensing,
                        Spin-Off, Joint Venture). Other sections cover Market Assessment and Validation
                         Methodologies, Business Model Development, and achieving Investment Readiness 
                         through various funding strategies. This holistic approach is designed to provide
                          researchers and entrepreneurs with the roadmap and tools necessary to navigate
                           the complex journey from the lab to the market.
                </p>
               </div>

                <div className='uk-width-1-2@s'>
                  <img src= {lab} />
               </div>
            </div>
        </div>
        </Layout>
  )
}

export default Lab_to_market